import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import Header from "./Components/Common/Header";
import Footer from "./Components/Common/Footer";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Pickup from "./Components/Pickup/Pickup";
import DevStatus from "./Components/DevStatus/DevStatus";
import Contact from "./Components/Contact/Contact";

function App() {
  return (
    <div className='App'>
      <Router>
        <Header />
        <div className='wrapper'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/donate' element={<Pickup />} />
            <Route path='/dev-status' element={<DevStatus />} />
            <Route path='/contact' element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
